<template>
  <div class="custom-control custom-switch mt-3">
    <input
      id="pause-animation"
      class="custom-control-input pause-animation"
      type="checkbox"
      @change="toggleAnimation"
    />
    <label class="custom-control-label pause-animation" for="pause-animation">
      Pause Animation
    </label>
  </div>
</template>

<script>
export default {
  name: 'AnimationToggle',
  methods: {
    toggleAnimation () { this.$store.commit('toggleAnimations') },
  }
}
</script>
